import { render, staticRenderFns } from "./DataBoardTable.vue?vue&type=template&id=af156b78"
import script from "./DataBoardTable.vue?vue&type=script&lang=js"
export * from "./DataBoardTable.vue?vue&type=script&lang=js"
import style0 from "./DataBoardTable.vue?vue&type=style&index=0&id=af156b78&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af156b78')) {
      api.createRecord('af156b78', component.options)
    } else {
      api.reload('af156b78', component.options)
    }
    module.hot.accept("./DataBoardTable.vue?vue&type=template&id=af156b78", function () {
      api.rerender('af156b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dataBoard/components/DataBoardTable.vue"
export default component.exports